import React from 'react';

function RadioCircle(props) {
    const stroke = props.stroke;
    const selected = props.selected;
    const fill = props.fill;
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="16" 
            height="16" 
            viewBox="0 0 16 16" 
            fill="none"
        >
            <circle 
                cx="8" 
                cy="8" 
                r="7.25" 
                fill="white" 
                stroke={stroke}
            />
            {
                selected === true &&
                <circle 
                    cx="8" 
                    cy="8" 
                    r="5" 
                    fill={fill}    
                />
            }
        </svg>
    )
};

export default RadioCircle;